import styled from '@emotion/styled'
import { getScreenSizes } from '@pretamanger/component-library'
import tw from 'twin.macro'
import TransactionalProductCard from '#src/products/components/list/product-card'

export const ExtraDetailsRowWrapper = styled.div`
  ${tw`box-border mb-4 border border-grey-300`}
`
export const ExtrasDetailsRow = styled.div`
  ${tw`flex justify-between pb-6 pt-6 `}
`
export const ProductDetailsWrapper = styled.div`
  ${tw`flex flex-col md:flex-row`}
`
export const Price = styled('p')`
  ${tw`text-lg text-black flex-auto md:text-right md:mx-8`}
`
export const RecommendationsProductCard = styled(TransactionalProductCard)`
  ${tw`mt-8`}
`
export const RecommendationsProductCardContainer = styled.div`
  ${tw`space-y-10`}
`
export const CardWrapper = styled('div')`
  ${tw`relative py-5 sm:py-0`}
  ${tw`border-b border-grey-200 mb-4`}
  ${tw`border`}
  [name="recommendations"] & {
    ${tw`border-b-0 pb-0 sm:border-b`}
  }
  @media (max-width: ${getScreenSizes().sm}px) {
    &:first-of-type {
      ${tw`pt-0`}
    }
    &:last-of-type {
      ${tw`mb-4`}
    }
  }

  h4 {
    ${tw`mb-0`}
  }
`
